<p-badge 
    [value]="value"
    [severity]="severity"
></p-badge>